/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

export const IMAGE_TYPES = {
    BACKGROUND: "background cover",
    TAG: "image tag"
};

// export const default_image = {
//     url: `/images/missing_image.jpg`,
//     width: 240,
//     type: IMAGE_TYPES.BACKGROUND,
//     position: 'center center',
// }

export const width = "100%";
export const height = "100px";

export const cardStyle = {
    borderRadius: "0.5rem",
    boxShadow: "none",
    position: "relative",
    width: width,
    height: height,
    backgroundColor: "rgba(214,215,214,0.67)",
    padding: "0 12px",
    "&:after": {
        content: "\"\"",
        display: "block",
        position: "absolute",
        width: "100%",
        height: "64%",
        bottom: 0,
        zIndex: 1,
        background: "linear-gradient(to top, #000, rgba(0,0,0,0))",
        backgroundColor: "#000000aa",
        // border: '1px solid red',
    },
};
export const contentStyle = {
    border: "1pz solid red",
    position: "absolute",
    zIndex: 2,
    bottom: 0,
    width: "100%",
    background: "linear-gradient(to top, #000, rgba(0,0,0,0))",
};
export const contentTopStyle = {
    position: "absolute",
    zIndex: 2,
    top: 0,
    width: "100%",
    // background: 'linear-gradient(to bottom, rgba(0,0,0,0.4), rgba(0,0,0,0))',
    
};
export const mediaStyles = { backgroundColor: "#353a35" };
export const metaStyle = {};
export const textHeadingStyle = {
    color: "#212121",
    fontWeight: "700",
    fontFamily: "Public Sans,sans-serif",
    fontSize: "12px",
};
export const textStyle = {
    color: "#E9E9E9",
    fontWeight: "400",
    fontFamily: "Public Sans,sans-serif",
    fontSize: "11px",
};

// export default {
//     formatBytes,
//     default_image,
//     width,
//     height,
//     cardStyle,
//     contentStyle,
//     contentTopStyle,
//     mediaStyles,
//     metaStyle,
//     textHeadingStyle,
//     textStyle,
//     bytes,
//     IMAGE_TYPES,
// }
